import React from 'react';
import { CommonPageStep, ResetPasswordPageStep } from '..';
import * as qs from 'query-string';
import { isMobileOnly } from 'react-device-detect';
import { Navigate } from 'react-router-dom';
import { MobileView } from './mobile/NotFound.mobile';
import { useAppSelector } from '../../store/hooks';
import {
  selectAppPageStep,
  setAppPageStep,
} from '../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../store/store';

export const NotFound = (): JSX.Element => {
  // Redux Hooks
  const appPageStep = useAppSelector(selectAppPageStep);

  // LOCAL HOOKS

  // ELEMENT FUNCTIONS

  React.useEffect(() => {
    outsideComponentDispatch(setAppPageStep(CommonPageStep.NOTFOUND));
  }, []);

  return (
    <React.Fragment>
      {/* 404 SAME VERSION ON MOBILE / DESKTOP */}
      {isMobileOnly ? <MobileView /> : <MobileView />}
      {appPageStep === CommonPageStep.LOGIN ? <Navigate to="/Login" /> : null}
    </React.Fragment>
  );
};
